import bs58 from 'bs58';
import nacl from 'tweetnacl';

export type CreateNaClSharedSecretParams = {
  ourSecretKey: string;
  theirPublicKey: string;
};

/**
 * Creates a shared secret for NaCl box encryption using our secret key and their public key.
 *
 * @param params.ourSecretKey - Our base58-encoded secret key
 * @param params.theirPublicKey - Their base58-encoded public key
 * @returns The base58-encoded shared secret
 */
export const createNaClSharedSecret = ({
  ourSecretKey,
  theirPublicKey,
}: CreateNaClSharedSecretParams): string => {
  const sharedSecret = nacl.box.before(
    bs58.decode(theirPublicKey),
    bs58.decode(ourSecretKey)
  );

  return bs58.encode(sharedSecret);
};
